import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { GraduationCap, Building2, Briefcase, ArrowRight } from 'lucide-react';

const features = [
  {
    icon: GraduationCap,
    title: 'Gyakorlati tréningek',
    description: 'Azonnal alkalmazható tudás, amely nem jegyzetekben marad. Interaktív workshopok, valós szituációk, azonnali visszajelzés.',
    cta: 'Képzések megtekintése',
    link: '/#kepzesek',
  },
  {
    icon: Building2,
    title: 'Ingatlanközvetítői karrier',
    description: 'Stabil szakmai háttér az ingatlanpiacon. Átfogó képzés, mentorálás, és folyamatos szakmai támogatás a sikeres karrierhez.',
    cta: 'Tudj meg többet',
    link: '/ingatlan',
  },
  {
    icon: Briefcase,
    title: 'Céges fejlesztések',
    description: 'Testreszabott tréningprogramok vállalatoknak. A csapatod fejlődése mérhető eredményekben, nem csak workshopokon.',
    cta: 'Ajánlatkérés',
    link: '/b2b',
  },
];

export const WhyUs = () => {
  return (
    <section className="section-padding relative" data-testid="whyus-section">
      <div className="absolute inset-0 z-0">
        <img loading="lazy" src="https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg?auto=compress&cs=tinysrgb&w=1920" alt="Szakemberek együttműködése — vezetői és csapatfejlesztő tréning" className="w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-black/75" />
      </div>
      <div className="container-custom relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.3 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <p className="text-[#C4DB72] font-mono text-sm tracking-widest uppercase mb-4">
            Miért az Akadémia?
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-white">
            Három út a fejlődéshez
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-4 md:gap-8">
          {features.map((feature, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false, amount: 0.3 }}
              transition={{ delay: idx * 0.1, duration: 0.6 }}
              className="group"
            >
              <div className="training-card h-full flex flex-col card-blue">
                <div className="w-12 h-12 md:w-16 md:h-16 bg-[#FBAF3F]/20 flex items-center justify-center mb-4 md:mb-6 group-hover:bg-[#FBAF3F]/30 transition-colors">
                  <feature.icon size={32} className="text-[#FBAF3F]" />
                </div>
                <h3 className="font-heading text-2xl font-semibold text-white mb-4">
                  {feature.title}
                </h3>
                <p className="text-white/60 leading-relaxed mb-6 flex-grow">
                  {feature.description}
                </p>
                <Link
                  to={feature.link}
                  className="inline-flex items-center gap-2 text-[#C4DB72] hover:text-[#91C36D] font-medium transition-colors group/link"
                  data-testid={`whyus-cta-${idx}`}
                >
                  {feature.cta}
                  <ArrowRight size={16} className="group-hover/link:translate-x-1 transition-transform" />
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
